import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class Reconnect extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Reconnect');
    public static getDescription:Function = () => Locale.gettext('The Attendant has reconnected to the cloud');
    public static supportedRoutes:string[] = [ "push", "email" ];
}